<template>
    <div id="notFound">Not Found 404</div>
</template>

<script>
export default {
    name: 'NotFound',
    components: {},
    data() {
        return {};
    },
    computed: {
        // ...mapGetters('status', ['getFbStatus']),
    },
    methods: {},
};
</script>
